<script>
export default {
  name: "ReservationFrequencyTypeBadge",
  props: {
    reservationFrequencyTypeId: {
      type: String,
      default: ''
    },
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.zzReservationFrequencyTypeIdBgColor[this.reservationFrequencyTypeId] ?? ''
    },
    getText() {
      return this.$constant.zzReservationFrequencyTypeText[this.reservationFrequencyTypeId] ?? ''
    },
  },
}
</script>

<template>
  <span
    class="badge font-size-12"
    :style="{
      'background-color': this.getBackgroundColor(),
    }"
  >{{ getText() }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 0.4em 0.5em;
}
</style>
